// Carga Académica (PUCV, formato Anexo 4; ver $usesAcademicLoad en main.js). Las horas por
// División de tiempo se ingresan semanales y se guardan totales (semanales × semanas de la
// asignatura), igual que el Plan de Estudio. Los totales siguen las reglas de pucvCredits.js.
import {
  PUCV_SEMESTER_WEEKS,
  pucvWeeklyHours,
  toPucvPedagogicalHours,
} from "@/utils/pucvCredits";

// Mismas claves que PERIODICITY_CHOICES en kl-backend (mesh/models.py)
export const PERIODICITIES = ["weekly", "monthly", "bimonthly", "semiannual"];

// Opciones para un select; "" es "sin periodicidad" y se muestra como "-"
export function periodicityOptions(t) {
  return [
    { value: "", text: "-" },
    ...PERIODICITIES.map((periodicity) => ({
      value: periodicity,
      text: t(`studyPlan.academicLoad.periodicities.${periodicity}`),
    })),
  ];
}

export function periodicityLabel(t, periodicity) {
  return PERIODICITIES.includes(periodicity)
    ? t(`studyPlan.academicLoad.periodicities.${periodicity}`)
    : "-";
}

// { [time_allocation_id]: división } de una asignatura del perfil: las de la Asignatura Base
// si usa sus valores (use_matter_values), si no las propias del perfil.
export function allocationsOfMatter(
  egress_profile_matter,
  matter_time_allocations,
  ep_matter_time_allocations
) {
  const allocations = {};
  if (egress_profile_matter.use_matter_values)
    matter_time_allocations
      .filter((x) => x.matter == egress_profile_matter.matter)
      .forEach((x) => (allocations[x.time_allocation] = x));
  else
    ep_matter_time_allocations
      .filter((x) => x.egress_profile_matter == egress_profile_matter.id)
      .forEach((x) => (allocations[x.time_allocation] = x));
  return allocations;
}

export function weeklyHours(hours, weeks) {
  const total = parseFloat(hours) || 0;
  const week_count = parseFloat(weeks) || 0;
  if (total <= 0 || week_count <= 0) return 0;
  return parseFloat((total / week_count).toFixed(2));
}

export function totalHoursFromWeekly(weekly_hours, weeks) {
  const weekly = parseFloat(weekly_hours) || 0;
  if (weekly <= 0) return 0;
  return weekly * (parseFloat(weeks) || 0);
}

// Horas presenciales semanales en horas PUCV (35 min): solo divisiones que cuentan para
// créditos, separando pedagógicas (minutos del módulo) y cronológicas (60), como MatterForm.
// allocations: { [time_allocation_id]: MatterTimeAllocation o EgressProfileMatterTimeAllocation }
export function presentialWeeklyHours(
  allocations,
  time_allocations,
  weeks,
  module_minutes
) {
  let pedagogical = 0;
  let chronological = 0;
  time_allocations.forEach((time_allocation) => {
    const allocation = allocations[time_allocation.id];
    if (!allocation || !allocation.counts_towards_credits) return;
    const hours = weeklyHours(allocation.hours, weeks);
    if (time_allocation.uses_module_minutes) pedagogical += hours;
    else chronological += hours;
  });
  const hours = toPucvPedagogicalHours(
    pedagogical,
    chronological,
    module_minutes
  );
  return parseFloat(hours.toFixed(2));
}

// Columnas "Totales Horas" del Anexo 4. Autónomo = c × 4 − presencial: si es negativo la
// asignatura tiene más horas presenciales de las que permiten sus créditos.
export function academicLoadTotals(pucv_credits, presential_weekly) {
  const dedication_weekly = pucvWeeklyHours(pucv_credits);
  const autonomous_weekly = parseFloat(
    (dedication_weekly - presential_weekly).toFixed(2)
  );
  const semester = (weekly) =>
    parseFloat((weekly * PUCV_SEMESTER_WEEKS).toFixed(2));
  return {
    presential_weekly: presential_weekly,
    presential_semester: semester(presential_weekly),
    autonomous_weekly: autonomous_weekly,
    autonomous_semester: semester(autonomous_weekly),
    dedication_weekly: dedication_weekly,
    dedication_semester: semester(dedication_weekly),
  };
}
